
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/events/[eventId]/reception",
      function () {
        return require("private-next-pages/events/[eventId]/reception.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/events/[eventId]/reception"])
      });
    }
  